import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["conversation"]

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.revealConversations()
            this.observer.disconnect()
          }
        })
      },
      { threshold: 0.2 }
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  revealConversations() {
    this.conversationTargets.forEach((el, index) => {
      setTimeout(() => {
        el.classList.remove("opacity-0", "translate-y-4")
        el.classList.add("opacity-100", "translate-y-0")
      }, index * 400)
    })
  }
}
